export default "__VITE_ASSET__b4bae7d6__"